import React from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../../Images/logo.svg';
import './Header.css';

export default function Header() {
    return(
        <header>
            <div className="left">
                <NavLink exact to="/">
                    <img src={Logo} alt="logo" draggable="false"/>
                </NavLink>
                <div className="nav_button" onClick={() => {
                    if(document.getElementsByTagName('header')[0].style.height != '155px' ){
                        document.getElementsByTagName('header')[0].style="height: 155px";
                        document.getElementsByClassName('line')[0].style = "margin: -5px 0;";
                        document.getElementsByClassName('line')[1].style = "margin: -5px 0;";
                        document.getElementsByClassName('line')[2].style = "margin: -5px 0;";
                    }else{
                        document.getElementsByTagName('header')[0].style="height: 42px";
                        document.getElementsByClassName('line')[0].style = "margin: 5px 0;";
                        document.getElementsByClassName('line')[1].style = "margin: 5px 0;";
                        document.getElementsByClassName('line')[2].style = "margin: 5px 0;";
                    }
                }}>
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                </div>
            </div>
            <div className="right">
                <ul>
                    <li>
                        <NavLink exact to="/" activeClassName="active">Home</NavLink>
                    </li>
                    <li>
                        <NavLink exact to="/docs" activeClassName="active">Docs</NavLink>
                    </li>
                    <li>
                        <NavLink to="/about" activeClassName="active">About</NavLink>
                    </li>
                    <li>
                        <NavLink to="/support" activeClassName="active">Support</NavLink>
                    </li>
                </ul>
            </div>
        </header>
    );
}